import Constants from "@/mixins/constants.js";
import ResponsiveMixin from "@/mixins/responsive.js";

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));


export default {
  mixins: [Constants, ResponsiveMixin],

  data: () => {
    return {
      /** four non-breaking spaces in a row*/
      spacing: " ",
      /** base64 prefix for displaying images encoded in base64 in v-img/img tags */
      base64ImgPrefix: "data:image/jpeg;base64,",
    };
  },

  methods: {

/**
 * sets a cookie with a specified key/name and value, and optional expiration and 'forever' flag.
 * @param {string} key - the key/name of the cookie.
 * @param {string} value - the value of the cookie.
 * @param {number} [days] - the number of days until the cookie expires.
 * @param {boolean} [forever=false] - If true, sets the cookie to expire at a far future date.
 */
setCookie(key, value, days, forever = false) {
  var expires = "";
  if (forever) {
      // set expiration date to a far future date for 'forever' cookies
      expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
  } else if (days) {
      // calculate expiration date for cookies with a specified lifetime
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }

  // set the cookie with the key/name, value, expiration, and path
  document.cookie = key + "=" + (value || "") + expires + "; path=/";
},

/**
 * retrieves the value of a cookie with a specified key/name.
 * @param {string} key - the key/name of the cookie to retrieve.
 * @returns {string|null} the value of the cookie, or null if the cookie does not exist.
 */
getCookie(keyToRetrieve) {
  var cookieEQ = keyToRetrieve + "=";

  // split document.cookie into an array of cookies and trim whitespace
  var ca = document.cookie.split(';').map(cookie => cookie.trim());

  // filter the array to find the cookie with the specified name
  var filteredCookies = ca.filter(cookie => cookie.indexOf(cookieEQ) == 0);
  
  // return the value of the cookie if found, otherwise return null
  if (filteredCookies.length > 0) {
      return filteredCookies[0].substring(cookieEQ.length);
  }

  return null;
},

/**
 * deletes a cookie with a specified key/name.
 * @param {string} keyToDelete - the key/name of the cookie to delete.
 */
deleteCookie(keyToDelete) {   
  // set the cookie with an immediate expiration date to delete it
  document.cookie = keyToDelete + '=; Max-Age=-99999999;';  
},
    /** removes any html occurence in a string */
    stripHtml(html) {
      // parse escaped html to html
      html = new DOMParser().parseFromString(html, "text/html").documentElement.textContent;
      return html.replace(/<[^>]*>/g, '');
    },
    /** checks an object for undefined-/null-values */
    checkObj(objToCheck) {
      var isNull = objToCheck === null;
      var isUndefined = objToCheck === undefined;

      if (!isNull && !isUndefined) {
        var isEmpty = Object.keys(objToCheck).length === 0;
      }

      return !isNull && !isUndefined && !isEmpty;
    },

    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        return true;
      return false;
  },

    copyToClipboard(valueToWrite) {
      navigator.clipboard.writeText(valueToWrite);
      this.$root.snackbar.show(this.$root.snackbars.copiedValue);
    },

    /** returns whether a string is null, empty, or consists only of white-space characters */
    isNoWs(stringToCheck) {
      return stringToCheck === null || stringToCheck === undefined || String(stringToCheck).match(/^ *$/) !== null;
    },

    /** takes two dates and formats them so that they can be displayed on the ui */
    getFancyDatestring(startDate, endDate) {
      let dateFrom = this.$d(new Date(startDate), "longDate");
      let dateTo = this.$d(new Date(endDate), "longDate");
      return dateFrom + this.spacing + "—" + this.spacing + dateTo;
    },

    /** takes two times and formats them so that they can be displayed on the ui */
    getFancyTimestring(startTime, endTime, withClockSuffix = false, format = true) {
      var timeTo, timeFrom;
      if (format) {
        timeFrom = this.$d(new Date(startTime), "time");
        timeTo = this.$d(new Date(endTime), "time");
      } else {
        timeFrom = startTime;
        timeTo = endTime;
      }

      var timeToReturn;

      if (withClockSuffix) {
        timeToReturn = timeFrom + this.spacing + this.$t('common.label_clock') + this.spacing + "—" + this.spacing + timeTo + this.spacing + this.$t('common.label_clock');
      } else {
        timeToReturn = timeFrom + this.spacing + "—" + this.spacing + timeTo;
      }
      
      return timeToReturn;
    },

    addMinutesToDateObj(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    },

    subtractMinutesFromDateObj(date, minutes) {
      return new Date(date.getTime() - minutes * 60000);
    },
    /**
     * helper method, for asynchronous Array.filter operations
     *
     * @param {*} arrayToFilter array that should be filtered
     * @param {*} predicate filter function
     * @return {*} asynchronous filtered array
     */
    async filterAsync(arrayToFilter, predicate) {
      /*
        the problem:
        Array.filter returns a new array containing only the elements for which the predicate* resulted in "true"

        since Array.filter is synchronous, but loading halls must perform an asynchronous operation (API call),
        i was looking for a way to filter an array and perform an asynchronous operation in it


        the solution:
        i came across this post by Tamás Sallai:
        https://advancedweb.hu/how-to-use-async-functions-with-array-filter-in-javascript/

        he even included a very good sequence diagram:
        https://advancedweb.hu/assets/5dbbe904f0eac0d83aa913f1a1a24ed910a95aadf3e4522d3498e2dfbe9f70a3.svg
        
        tl;dr:
        in his post he maps the array through the predicate function asynchronously, resulting in true/false values
        then he filters the promises from the mapping to true/false


        where i had my fingers in the pie:
        in my tests i had problems with undefined values in the result so i extended this function
        if a predicate returns false, an Symbol is written to the Promise result, then i filter out all the Symbol-results
        
        *a predicate is a function that returns true or false - depending on the condition
       */
      const failedOperation = Symbol();

      var mappedPredicates = await Promise.all(
        arrayToFilter.map(async (item) => {
          // the result is always a boolean, assuming the predicate returns true/false...
          let predicateResult = await predicate(item);

          if (predicateResult) {
            return item;
          } else {
            return failedOperation;
          }
        })
      );

      var filteredElements = mappedPredicates.filter((mapRes) => mapRes !== failedOperation);

      return filteredElements;
    },

    /**
     * checks whether an object represents a hall or a course
     *
     * @param {Object} cvpObject course/hall object
     *
     * @returns TYPE_COURSES object represents a course
     * @returns TYPE_HALLS object represents a hall
     * @returns undefined object is neither course nor hall
     */
    getType(cvpObject) {
      var objectKeys = Object.keys(cvpObject);

      var courseDiff = this.COURSE_OBJECT_KEYS.filter((key) => !objectKeys.includes(key)).length;
      var hallDiff = this.HALL_OBJECT_KEYS.filter((key) => !objectKeys.includes(key)).length;

      if (courseDiff === 0 && hallDiff === 0) return undefined;

      var tmpCourseDiff = undefined;
      if (courseDiff === 0) tmpCourseDiff = this.TYPE_COURSES;

      if (hallDiff === 0) {
        if (tmpCourseDiff !== undefined) {
          return "dont know what to do here, you got a very strange object..";
        } else {
          return this.TYPE_HALLS;
        }
      } else {
        return tmpCourseDiff;
      }
    },

    getFullDayName(dayAbbreviation, returnAsNumber = false) {
      const weekdaysOrder = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
      
      const dayNames = {
          'So.': this.$t('weekdays.day_0'),
          'Mo.': this.$t('weekdays.day_1'),
          'Di.': this.$t('weekdays.day_2'),
          'Mi.': this.$t('weekdays.day_3'),
          'Do.': this.$t('weekdays.day_4'),
          'Fr.': this.$t('weekdays.day_5'),
          'Sa.': this.$t('weekdays.day_6')
      };

      if (returnAsNumber) {
        return weekdaysOrder.indexOf(dayAbbreviation);
    } else {
        return dayNames[dayAbbreviation] || dayAbbreviation;
    }
  },
  /** determines if the action area of the ApplicationWrapper should be spreaded in two lines */
  async shouldWrapActionsInTwoLines() {
    if (!this.isMobile() || this.currentBreakpoint > 1) return false;

    await this.$nextTick()
    await this.$nextTick()

      var actionElement = document.getElementById('wrapper-actions');
      if (!actionElement) return false;

      var childElementCount = actionElement.children[0]?.children.length;
      
      return childElementCount > 1;
  },
    /** determines if the text color should be black or white depending on the background color of a tag */
    invertColor(hexColorCode) {
      var hexCode = hexColorCode;

      if (hexCode == "transparent") return;
      
      if (hexCode.indexOf("#") === 0) {
        hexCode = hexCode.slice(1);
      } else {
        throw new Error("invalid hexCode color.");
      }

      // convert possible 3-digit hexCode to 6-digits
      if (hexCode.length === 3) {
        hexCode = hexCode[0] + hexCode[0] + hexCode[1] + hexCode[1] + hexCode[2] + hexCode[2];
      }

      if (hexCode.length !== 6) {
        throw new Error("invalid hexCode color.");
      }

      var rgbRed = parseInt(hexCode.slice(0, 2), 16);
      var rgbGreen = parseInt(hexCode.slice(2, 4), 16);
      var rgbBlue = parseInt(hexCode.slice(4, 6), 16);

      // thanks to Mark Ransom: https://stackoverflow.com/a/3943023/112731
      return rgbRed * 0.299 + rgbGreen * 0.587 + rgbBlue * 0.114 > 186 ? "#000000" : "#FFFFFF";
    },

    /** gets the next meeting of a booked or reserved course */
    getNextMeetingCourse(course) {
      var nextDate = new Date(course.bookingInfo.NextMeetingDate);

      var day = nextDate.getDate();
      var month = this.$t("months_short.month_" + nextDate.getMonth());

      return day + "<br/>" + month;
    },

    /** gets the next meeting of a booked hall */
    getNextMeetingHall(hall) {
      // get dates out of meeting object
      var nextDates = hall.BookedDates.map((bookedDate) => new Date(bookedDate.Date));
      // sort dates, take first
      var nextDate = nextDates.sort((dateA, dateB) => (dateA > dateB ? this.SORT_A_BEFORE_B : this.SORT_B_BEFORE_A))[0];

      var day = nextDate.getDate();
      var month = this.$t("months_short.month_" + nextDate.getMonth());

      return day + "<br/>" + month;
    },

    /** gets the next meeting of a hall */
    getNextMeetingDateHall(hall) {
      // get dates out of meeting object
      var nextDates = hall.BookedDates.map((bookedDate) => new Date(bookedDate.Date));
      // sort dates, take first
      var nextDate = nextDates.sort((dateA, dateB) => (dateA > dateB ? this.SORT_A_BEFORE_B : this.SORT_B_BEFORE_A))[0];

      return this.$d(nextDate, "longDate");
    },

    /** gets the next meeting of a course */
    getNextMeetingDateCourse(course, returnDateObj = false) {
      if (!course.meetings) {
        return "";
      }

      // get dates out of meeting object
      var nextDates = course.meetings.map((meeting) => new Date(meeting.MeetingDate));
      // sort dates, take first
      var nextDate = nextDates.sort((dateA, dateB) => (dateA > dateB ? this.SORT_A_BEFORE_B : this.SORT_B_BEFORE_A))[0];

      if (returnDateObj) {
        return new Date(nextDate);

      }

      return this.$d(new Date(nextDate), "longDate");
    },
  },
};
